module.exports = __webpack_public_path__ + "static/media/logo-inverted.7e8503ac.svg";